import React from 'react';
import { AppBar, Toolbar, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Topbar = ({ isSidebarOpen, drawerWidth = 220, miniWidth = 60 }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('admin_logged_in');
    localStorage.removeItem('admin_username');
    navigate('/admin');
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        ml: isSidebarOpen ? `${drawerWidth}px` : `${miniWidth}px`,
        width: `calc(100% - ${isSidebarOpen ? drawerWidth : miniWidth}px)`,
        backgroundColor: '#111827',
        transition: 'all 0.3s ease',
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h5" fontWeight="600">
          Dashboard
        </Typography>

        <Button
          variant="contained"
          color="error"
          onClick={handleLogout}
          sx={{ borderRadius: '8px' }}
        >
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;
